import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';

export const ValidationLayout = () => {
    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    );
};
